import React from 'react';
import { Activity, Users, CheckCircle, BookOpen, Clock, BarChart3, Zap } from 'lucide-react';
import type { LearningEngagement } from '@/services/PagesServices/AnalyticsService';

interface EngagementCardProps {
  engagement: LearningEngagement;
}

const EngagementCard: React.FC<EngagementCardProps> = ({ engagement }) => {
  return (
    <div className="analytics-section" style={{ marginBottom: 0 }}>
      <div className="analytics-section-header-row">
        <div>
          <div className="analytics-section-title">
            <Activity size={20} className="analytics-section-icon" />
            Learning Engagement
          </div>
          <div className="analytics-section-subtitle">Platform-wide engagement metrics</div>
        </div>
      </div>
      <div className="analytics-engagement-grid">
        <div className="analytics-engagement-item">
          <div className="analytics-engagement-icon-wrap" style={{ background: '#eef2ff' }}>
            <Users size={18} color="#6366f1" />
          </div>
          <div className="analytics-engagement-value">{engagement.totalActiveUsers}</div>
          <div className="analytics-engagement-label">Total Active Users</div>
        </div>
        <div className="analytics-engagement-item">
          <div className="analytics-engagement-icon-wrap" style={{ background: '#dcfce7' }}>
            <CheckCircle size={18} color="#16a34a" />
          </div>
          <div className="analytics-engagement-value">{engagement.usersWithEnrollments}</div>
          <div className="analytics-engagement-label">Users with Enrollments</div>
        </div>
        <div className="analytics-engagement-item">
          <div className="analytics-engagement-icon-wrap" style={{ background: '#fff3e8' }}>
            <BookOpen size={18} color="#ff8c42" />
          </div>
          <div className="analytics-engagement-value">{engagement.totalEnrollments}</div>
          <div className="analytics-engagement-label">Total Enrollments</div>
        </div>
        <div className="analytics-engagement-item">
          <div className="analytics-engagement-icon-wrap" style={{ background: '#fef3c7' }}>
            <Clock size={18} color="#f59e0b" />
          </div>
          <div className="analytics-engagement-value">{engagement.totalTimeSpent}h</div>
          <div className="analytics-engagement-label">Total Time Spent</div>
        </div>
        <div className="analytics-engagement-item">
          <div className="analytics-engagement-icon-wrap" style={{ background: '#f0f9ff' }}>
            <BarChart3 size={18} color="#0ea5e9" />
          </div>
          <div className="analytics-engagement-value">{engagement.avgTimePerUser}h</div>
          <div className="analytics-engagement-label">Avg Time Per User</div>
        </div>
        <div className="analytics-engagement-item">
          <div className="analytics-engagement-icon-wrap" style={{ background: '#fce7f3' }}>
            <Zap size={18} color="#ec4899" />
          </div>
          <div className="analytics-engagement-value">{engagement.activeUsersLast7Days}</div>
          <div className="analytics-engagement-label">Active Last 7 Days</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(EngagementCard);
